module.exports = __webpack_public_path__ + "fa5b84f497954784963985d52ef7603d.jpg";